export default {
  year: 2015,
  edition: "제 11회",
  date: "2015년 11월 23일 월요일",
  time: "오후 7시 ~ 10시",
  location: "리치과학관 R912 / R914",
  links: {
    problems: {
      BOJ: "https://www.acmicpc.net/category/detail/1420",
    },
  },
  authors: [],
  contests: [
    {
      title: "SPC 2015 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "4", "이건철"],
        ["2", "3", "황기덕"],
        ["3", "3", "박동규"],
        ["4", "3", "최광희"],
        ["5", "3", "권태국"],
        ["6", "3", "이아현"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/board/141"]],
    },
    {
      title: "SPC 2015 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "4", "김숭"],
        ["2", "2", "김준민"],
        ["3", "2", "안웅찬"],
        ["4", "1", "김도현"],
        ["5", "1", "이승제"],
        ["6", "1", "오준석"],
        ["7", "1", "김태완"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/board/142"]],
    },
  ],
};
